<template>
  <div>
    <div class="container action-container-div">
      <h1 class="h1-action-plan">Action Plan</h1>
        <div class="about-plan-container">
          <p class="about-plan-p">FleetREDI is an online portal for industry and government partners to access commercial vehicle data, with a goal of supporting research and development for renewable medium- and heavy-duty vehicle technologies and accelerating the transition to zero-emission vehicles.</p>
          <div class="plan-list-div">
              <p> Using a continual process of improvement, FleetREDI aims to:
              <ul>
                <li>
                  <strong>Identify</strong> existing commercial vehicle data and prioritize data collection for needed areas
                </li>
                <li>
                  <strong>Develop</strong> novel classification systems to enable data integration and innovative analysis.
                </li>
                <li>
                  <strong>Analyze</strong> compiled data sources to answer key research questions and support research, development, demonstration, and deployment.
                </li>
                <li>
                  <strong>Share</strong> key findings and insights with partners and stakeholders.
                </li>
              </ul>
              </p>
            </div>
          </div>
        </div>
      <div class="action-img-div d-flex flex-column align-items-center pt-4">
        <h2 class="display-6 text-center pb-3"><strong>FleetREDI Data Analysis Pipeline</strong></h2>
        <img class="action-img d-none d-sm-block" src="@/assets/images/actionplan/action-plan-page-graphic.png" alt="action graphic" />
    </div>
    <div class="container">
      <div class="row mb-3">
        <div class="col-12 col-md-6">
          <div class="card">
            <div class="row g-0">
              <div class="col-3 col-md-2">
                <img src="@/assets/images/actionplan/num-one.png" class="num-img" alt="number one">
              </div>
              <div class="col-9 col-md-8">
                <div class="card-body">
                  <p class="p-action-plan">Stakeholder Engagement</p>
                  <p class="card-text">Conduct stakeholder outreach to establish data needs and set research priorities.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="card">
            <div class="row g-0">
              <div class="col-3 col-md-2">
                <img src="@/assets/images/actionplan/num-two.png" class="num-img" alt="number two">
              </div>
              <div class="col-9 col-md-8">
                <div class="card-body">
                  <p class="p-action-plan">Needs Assessment</p>
                  <p class="card-text">Evaluate gaps in available commercial vehicle data and prioritize data needs, sources, and collection techniques.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 col-md-6">
          <div class="card">
            <div class="middle-row row g-0">
              <div class="col-3 col-md-2">
                <img src="@/assets/images/actionplan/num-three.png" class="num-img" alt="number three">
              </div>
              <div class="col-9 col-md-8">
                <div class="card-body">
                  <p class="p-action-plan">Classification Development</p>
                  <p class="card-text">Establish classification systems to enable data fusion, aggregation, and analysis.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="card">
            <div class="row g-0">
              <div class="col-3 col-md-2">
                <img src="@/assets/images/actionplan/num-four.png" class="num-img" alt="number four">          </div>
              <div class="col-9 col-md-8">
                <div class="card-body">
                  <p class="p-action-plan">Targeted Data Collection</p>
                  <p class="card-text">Acquire high-value data identified by research priorities and needs assessment.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="card">
            <div class="row g-0">
              <div class="col-3 col-md-2">
                <img src="@/assets/images/actionplan/num-five.png" class="num-img" alt="number five">
              </div>
              <div class="col-9 col-md-8">
                <div class="card-body">
                  <p class="p-action-plan">Secure Data Management</p>
                  <p class="card-text">Securely share data with stakeholders using NLR's Commercial Fleet Data Server.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="card">
            <div class="row g-0">
              <div class="col-3 col-md-2">
                <img src="@/assets/images/actionplan/num-six.png" class="num-img" alt="number six">
              </div>
              <div class="col-9 col-md-8">
                <div class="card-body">
                  <p class="p-action-plan">Data Analysis</p>
                  <p class="card-text">Apply innovative analysis and data science techniques to answer high-priority research questions.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
